import React from "react";

const Logo = ({ src, alt }) => (
    <img src={src} alt={alt} />
);

export default Logo